import axios from 'axios';
import { convertUtcDate } from '../components/Common/cleanDates';

import {
  REQUEST_OTHER_SERVICE,
  FETCH_OTHER_SERVICE_SUCCESS,
  FETCH_OTHER_SERVICE_FAILURE,
  SELECT_SALES_ORDER,
  RESET_CURRENT_SALES_ORDER,
  REQUEST_SALES_ORDER_DETAIL,
  FETCH_SALES_ORDER_DETAIL_SUCCESS,
  FETCH_SALES_ORDER_DETAIL_FAILURE,
} from './type';

import {
  SALES_ORDERS_URL,
  MOBILE_SALES_ORDERS_URL,
  SALE_OTHER_SERVICE_SEARCH_URL,
} from './url';

import { ROOT_URL, ROOT_API_URL } from './root_url';

import { DEFAULT_ERROR } from '../components/Common/constants';

export function requestOtherService() {
  return {
    type: REQUEST_OTHER_SERVICE,
  };
}

export function fetchOtherServiceSuccess(otherService) {
  return {
    type: FETCH_OTHER_SERVICE_SUCCESS,
    payload: otherService,
  };
}

export function fetchOtherServiceFailure(error) {
  return {
    type: FETCH_OTHER_SERVICE_FAILURE,
    payload: error,
  };
}

export function fetchOtherService() {
  return (dispatch) => {
    dispatch(requestOtherService());
    return axios.get(
      SALE_OTHER_SERVICE_SEARCH_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchOtherServiceSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchOtherServiceFailure(err));
      });
  };
}

export function selectSalesOrder(salesOrder) {
  return {
    type: SELECT_SALES_ORDER,
    payload: salesOrder,
  };
}


export function resetCurrentSalesOrder() {
  return {
    type: RESET_CURRENT_SALES_ORDER,
  };
}

// Fetch the detail page.
export function fetchSalesOrderDetail(salesOrder_id, route) {
  const url = (route == 'salesOrders') ? SALES_ORDERS_URL : MOBILE_SALES_ORDERS_URL;
  return (dispatch) => {
    dispatch(requestSalesOrderDetail());
    return axios.get(
      `${url}?pk=${salesOrder_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSalesOrderDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchSalesOrderDetailFailure(err));
      });
  };
}

export function requestSalesOrderDetail() {
  return {
    type: REQUEST_SALES_ORDER_DETAIL,
  };
}


export function fetchSalesOrderDetailSuccess(salesOrderDetail) {
  salesOrderDetail = salesOrderDetail.data;
  // The date data fetched is in the form of string, which needs to be modified into Date type
  if (salesOrderDetail.OrderDate) salesOrderDetail.OrderDate = convertUtcDate(salesOrderDetail.OrderDate);
  if (salesOrderDetail.ETADate) salesOrderDetail.ETADate = convertUtcDate(salesOrderDetail.ETADate);
  if (salesOrderDetail.ReceivedDate) salesOrderDetail.ReceivedDate = convertUtcDate(salesOrderDetail.ReceivedDate);
  if (salesOrderDetail.DispatchDate) salesOrderDetail.DispatchDate = convertUtcDate(salesOrderDetail.DispatchDate);
  return {
    type: FETCH_SALES_ORDER_DETAIL_SUCCESS,
    payload: salesOrderDetail,
  };
}

export function fetchSalesOrderDetailFailure(error) {
  return {
    type: FETCH_SALES_ORDER_DETAIL_FAILURE,
    payload: error,
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/otherService_actions.js